import { useState } from "react"
import { useTranslation } from "react-i18next";

export const useValidateDynamicForm = (initialState = {}) => {
    const { t } = useTranslation();
    const [errorInputs, setErrorInputs] = useState(initialState);

    const resetErrors = () => {
        setErrorInputs(initialState);
    }

    const handleErrorInput = (input, { isError = false, messageError = '' }) => {
        setErrorInputs((prevErrorInputs) => ({
            ...prevErrorInputs,
            [input]: {
                isError,
                messageError
            }
        }));
    }

    const validForm = (scheme, data, validation = null) => {
        let valid = true;
        scheme.forEach((item) => {
            if (item?.required) {
                if (item.type === 'date') {
                    if (!validDate(item.id, data[item.id])) valid = false;
                }
                else {
                    if (!validField(item.id, data[item.id], validation)) valid = false;
                }
            }
        });
        return valid;
    };

    const validDate = (name, dt) => {
        const date = new Date(dt);
        if (isNaN(date.getTime())) {
            handleErrorInput(name, { isError: true, messageError: t('validation.invalidDate') });
            return false;
        }
        return true;
    }

    const validField = (name, value, validation = null) => {
        if ((value === null || value === undefined || value.toString().trim() === '') && !validation) {
            handleErrorInput(name, { isError: true, messageError: t('validation.requiredField') });
            return false;
        } else {
            handleErrorInput(name, { isError: false, messageError: '' });
            return true;
        }
    };
    return [errorInputs, validForm, resetErrors, handleErrorInput];
}